const IMAGES = [
  {
    src: "/interior-4.jpg",
    span: "col-span-12 md:col-span-8 row-span-2",
    label: "Range Rover · interior detail",
    fit: "cover",
  },
  {
    src: "/exterior-1.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Subaru Legacy · exterior",
    fit: "cover",
  },
  {
    src: "/exterior-3.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Nissan · front detail",
    fit: "cover",
  },
  {
    src: "/exterior-2.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Nissan · rear detail",
    fit: "cover",
  },
  {
    src: "/interior-2.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Cockpit detail",
    fit: "cover",
  },
  {
    src: "/interior-3.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Mazda dashboard",
    fit: "cover",
  },
  {
    src: "/interior-5.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Two-tone leather detail",
    fit: "cover",
  },
  {
    src: "/interior-6.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Cabin reset",
    fit: "cover",
  },
  {
    src: "/interior-7.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Leather conditioning",
    fit: "cover",
  },
  {
    src: "/interior-8.jpg",
    span: "col-span-12 md:col-span-4",
    label: "Premium interior",
    fit: "cover",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32 bg-[#080808]/85 backdrop-blur-sm border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-gold">02 — The work</div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">
              Recent transformations.
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md">
            A glimpse of what comes out of our garage. Every detail documented,
            every finish hand-inspected.
          </p>
        </div>

        <div className="grid grid-cols-12 auto-rows-[260px] sm:auto-rows-[300px] gap-3 sm:gap-4">
          {IMAGES.map((img, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden rounded-xl group bg-black ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.label}
                className={`absolute inset-0 w-full h-full ${
                  img.fit === "contain" ? "object-contain" : "object-cover"
                } transition-transform duration-[1200ms] group-hover:scale-[1.04]`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-transparent pointer-events-none" />
              <figcaption className="absolute bottom-4 left-5 text-[11px] uppercase tracking-[0.2em] text-neutral-200">
                {img.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
